<template>
  <ToasterBase />
  <component :is="layout">
    <router-view />
  </component>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

import MainLayout from "@/components/Layouts/MainLayout.vue";
import BlankLayout from "@/components/Layouts/BlankLayout.vue";

import ToasterBase from "@/components/Common/ToasterBase.vue";

const route = useRoute();

const layout = computed(() => {
  const layoutName = route.meta.layout || "MainLayout";
  return (
    {
      MainLayout,
      BlankLayout,
    }[layoutName] || MainLayout
  );
});
</script>
